module.exports = __webpack_public_path__ + "static/media/map_dark-1.9ee818b4.png";